import { render, staticRenderFns } from "./ScannerInput.vue?vue&type=template&id=b2556288&"
import script from "./ScannerInput.vue?vue&type=script&lang=js&"
export * from "./ScannerInput.vue?vue&type=script&lang=js&"
import style0 from "./ScannerInput.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports